var Network = /* @__PURE__ */ ((Network2) => {
  Network2["Mainnet"] = "mainnet";
  Network2["Devnet"] = "devnet";
  Network2["Testnet"] = "testnet";
  Network2["Localnet"] = "localnet";
  Network2["Custom"] = "custom";
  return Network2;
})(Network || {});
function getAllNetworks() {
  const networksStringified = '{ "mainnet":{ "id":"mainnet", "name":"Mainnet", "url":"https://indexer.mainnet.iota.cafe", "graphql":"https://graphql.mainnet.iota.cafe", "explorer":"https://explorer.rebased.iota.org", "chain":"iota:mainnet", "kiosk": { "royaltyRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d", "kioskLockRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d", "floorPriceRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d", "personalKioskRulePackageId": "0xe49f2f23baf6c88a4c18478ac375033eea1f5609f2be6359b417208ea96f555d" } }, "testnet":{ "id":"testnet", "name":"Testnet", "url":"https://indexer.testnet.iota.cafe", "graphql":"https://graphql.testnet.iota.cafe", "explorer":"https://explorer.rebased.iota.org", "chain":"iota:testnet", "faucet":"https://faucet.testnet.iota.cafe", "kiosk": { "royaltyRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2", "kioskLockRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2", "floorPriceRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2", "personalKioskRulePackageId": "0x975f749f57701209454e4b9b9e33825ccb6a9abf57de2ce86979e5fa86c343f2" } }, "devnet":{ "id":"devnet", "name":"Devnet", "url":"https://indexer.devnet.iota.cafe", "graphql":"https://graphql.devnet.iota.cafe", "explorer":"https://explorer.rebased.iota.org","chain":"iota:devnet", "faucet":"https://faucet.devnet.iota.cafe" } }\n';
  if (!networksStringified) {
    throw new Error('"IOTA_NETWORKS" env var is not set.');
  }
  let networks;
  try {
    networks = JSON.parse(networksStringified);
  } catch {
    throw new Error('Failed to parse env var "IOTA_NETWORKS".');
  }
  return networks;
}
function getNetwork(network) {
  const networks = getAllNetworks();
  const requestedNetwork = networks[network] ?? network;
  return requestedNetwork;
}
function getDefaultNetwork() {
  return "mainnet";
}
function getFullnodeUrl(network) {
  return getNetwork(network).url;
}
function getGraphQLUrl(network) {
  return getNetwork(network).graphql;
}
export {
  Network,
  getAllNetworks,
  getDefaultNetwork,
  getFullnodeUrl,
  getGraphQLUrl,
  getNetwork
};
//# sourceMappingURL=network.js.map
